import moment from "moment";
import React, { useState } from "react";
import { Row, Col, Button, Form, Card, ButtonGroup, Alert, ProgressBar } from "react-bootstrap";
import _ from "lodash";
import axios from "axios";

import DateTimePicker from "react-datetime-picker";
import Utils from "./../../common/Utils";
import LeaveCalendar from "./LeaveCalendar";

const ApplyLeave = (props) => {
  const [apply, setApply] = useState({
    mode: false,
    applying: false,
    paid: 1,
    full: 1,
    hours: 0,
    fromDt: moment().toDate(),
    toDt: moment().toDate(),
  });
  const [lc, setLC] = useState(false);

  const applyingLeave = (e) => {
    var frm = e.currentTarget;
    e.preventDefault();

    /*if(apply.toDt===null){
        window.alert("Please select Leave Upto date!");
        return;
    }*/

    if (apply.full && moment(apply.fromDt).isAfter(moment(apply.toDt))) {
      window.alert("Please select dates correctly, TO date cannot be earlier than FROM date.");
      return;
    }

    const pvals = {
      paid: apply.paid,
      full: apply.full,
      fromDt: moment(apply.fromDt).format("YYYY-MM-DD"),
      reason: frm.reason.value,
    };

    if(apply.full===0){
      pvals['hours'] = apply.hours;
      pvals['toDt'] = pvals['fromDt'];
    }else{
      pvals['toDt'] = moment(apply.toDt ? apply.toDt : apply.fromDt).format("YYYY-MM-DD");
    }

    setApply({ ...apply, applying: true });
    axios
      .post(Utils.apiUrl("leaves/applyleave"), Utils.postVars(pvals), Utils.apiHeaders())
      .then((res) => {
        const data = Utils.parseApiResponse(res);
        if (data.success) {
          props.onApply();
          setApply({ ...apply, applying: false, mode: false });
        } else {
          window.alert(_.isObject(data.message) ? Object.values(data.message).join(",") : data.message);
          setApply({ ...apply, applying: false });
        }
      })
      .catch((err) => {
        console.log(err);
        window.alert("Network error while applying for holiday. Please try again.");
        setApply({ ...apply, applying: false });
      });
  };

  return (
    <>
      <Card border="primary" className="shadow">
        <Card.Body>
          <div
            className="d-flex justify-content-between clickable"
            title="Open/close Apply box"
            onClick={() => setApply({ ...apply, mode: !apply.mode })}
          >
            <div className="flex-start">
              <b>Apply for Holiday</b>
            </div>
            <div className="flex-end bg-none">
              {apply.mode === false && <b>+</b>}
              {apply.mode === true && <b>-</b>}
            </div>
          </div>

          {apply.applying === true && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">Processing your application, please wait..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}

          {apply.applying === false && apply.mode === true && (
            <div className="py-2">
              <Row className="g-3 align-items-center">
                <Col xs={12} sm={6} md={2}>
                  <label className="form-label small fw-bold d-block d-md-none">Duration</label>
                  <select className="form-select" value={apply.full} onChange={(e) => setApply({...apply, full: parseInt(e.target.value)})}>
                    <option value={1}>Full Day</option>
                    <option value={0}>Partial</option>
                  </select>
                </Col>

                {parseInt(apply.full) === 0 && (
                  <>
                    <Col xs={12} sm={6} md={3}>
                      <div className="d-flex align-items-center gap-2">
                        <span className="small text-muted text-nowrap">On:</span>
                        <DateTimePicker
                          minDate={moment().toDate()}
                          dayPlaceholder="dd"
                          monthPlaceholder="mm"
                          yearPlaceholder="yyyy"
                          clearIcon={null}
                          format="y-MM-dd"
                          onChange={(v) => setApply({ ...apply, fromDt: v })}
                          value={apply.fromDt}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={6} md={3}>
                      <div className="d-flex align-items-center gap-2">
                        <span className="small text-muted text-nowrap">Hours:</span>
                        <select className="form-select w-auto" value={apply.hours} onChange={(e) => setApply({...apply, hours: e.target.value})}>
                          {_.map(_.fill(new Array(49), 0), (v, idx2) => (
                            <option key={idx2} value={(idx2) / 4}>
                              {((idx2) / 4).toFixed(2)} Hrs.
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                  </>
                )}

                {parseInt(apply.full) === 1 && (
                  <Col xs={12} md={6}>
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      <div className="d-flex align-items-center gap-1">
                        <span className="small text-muted text-nowrap">From:</span>
                        <DateTimePicker
                          minDate={moment().toDate()}
                          dayPlaceholder="dd"
                          monthPlaceholder="mm"
                          yearPlaceholder="yyyy"
                          clearIcon={null}
                          format="y-MM-dd"
                          onChange={(v) => setApply({ ...apply, fromDt: v })}
                          value={apply.fromDt}
                        />
                      </div>
                      <div className="d-flex align-items-center gap-1">
                        <span className="small text-muted text-nowrap">To:</span>
                        <DateTimePicker
                          minDate={moment(apply.fromDt).startOf("day").toDate()}
                          dayPlaceholder="dd"
                          monthPlaceholder="mm"
                          yearPlaceholder="yyyy"
                          clearIcon={null}
                          format="y-MM-dd"
                          onChange={(v) => setApply({ ...apply, toDt: v })}
                          value={!_.isNull(apply.toDt) ? apply.toDt : apply.fromDt}
                        />
                      </div>
                    </div>
                  </Col>
                )}

                <Col xs={12} md={4}>
                  <div className="d-flex flex-wrap align-items-center gap-2 justify-content-md-end">
                    <div className="d-flex align-items-center gap-1">
                      <label className="form-label small fw-bold mb-0 text-muted">Type:</label>
                      <select className="form-select w-auto" value={apply.paid} onChange={(e) => setApply({...apply, paid: parseInt(e.target.value)})}>
                        <option value={1}>Paid</option>
                        <option value={0}>Unpaid</option>
                      </select>
                    </div>
                    <Button variant="outline-dark" size="sm" className="py-1 text-nowrap" onClick={() => setLC(!lc)}>
                      <i className="bi bi-calendar3 me-1" />View Calendar
                    </Button>
                  </div>
                </Col>
              </Row>
              <Form onSubmit={applyingLeave}>
                <Row>
                  <Col className="mt-3">
                    <Form.Control as="textarea" name="reason" required={true} placeholder="Reason: " rows={3}></Form.Control>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-center mt-3">
                    <Button type="submit" className="px-5">Submit</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          )}
        </Card.Body>
      </Card>
      {lc && <LeaveCalendar fromDt={apply.fromDt} toDt={apply.toDt} onHide={() => setLC(!lc)} />}
    </>
  );
};

export default ApplyLeave;
